export default "__VITE_ASSET__DjVvxU4u__"